/**
 * 签到 / 展示类大屏舞台：签到欢迎页、签到墙、启动仪式、倒计时、烟花等共用。
 * 头像墙来自 snapshot.topPlayers，标题来自场景 gameKey 对应玩法名。
 */
<template>
  <div class="signin-stage">
    <div class="signin-stage__bg" aria-hidden="true">
      <div class="signin-stage__glow signin-stage__glow--1" />
      <div class="signin-stage__glow signin-stage__glow--2" />
    </div>

    <div class="signin-stage__head">
      <div class="signin-stage__banner">{{ title || '欢迎入场' }}</div>
      <div class="signin-stage__stats">
        <span class="signin-stat">已入场 <em>{{ onlineCount }}</em> 人</span>
        <span class="signin-stat">展示 <em>{{ guests.length }}</em> 位嘉宾</span>
      </div>
    </div>

    <div class="signin-wall">
      <div v-for="p in guests" :key="p.uid" class="signin-item">
        <img v-if="p.avatar" class="signin-avatar" :src="p.avatar" alt="">
        <span v-else class="signin-avatar is-text">{{ (p.nick || p.nickName || '观').slice(0, 1) }}</span>
        <span class="signin-nick">{{ p.nick || p.nickName || '观众' }}</span>
      </div>
      <div v-if="!guests.length" class="signin-empty">
        <div class="signin-empty__title">等待观众入场…</div>
        <div class="signin-empty__tip">扫描现场二维码即可签到上墙</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SigninWallScreen',
  props: {
    guests: { type: Array, default: () => [] },
    onlineCount: { type: Number, default: 0 },
    title: { type: String, default: '' }
  }
}
</script>

<style scoped>
.signin-stage {
  position: absolute;
  inset: 0;
  overflow: hidden;
  color: #f5f7fa;
}
.signin-stage__bg {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 50% 42%, #173040 0%, #0c1a24 62%, #04080c 100%);
  overflow: hidden;
}
.signin-stage__glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.45;
}
.signin-stage__glow--1 {
  width: 38vw;
  height: 38vw;
  left: 4%;
  top: 8%;
  background: rgba(64, 200, 255, 0.36);
  animation: signinFloat 9s ease-in-out infinite alternate;
}
.signin-stage__glow--2 {
  width: 32vw;
  height: 32vw;
  right: 4%;
  bottom: 6%;
  background: rgba(255, 190, 90, 0.28);
  animation: signinFloat 11s ease-in-out infinite alternate-reverse;
}
.signin-stage__head {
  position: relative;
  z-index: 3;
  padding-top: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
}
.signin-stage__banner {
  display: inline-block;
  padding: 8px 36px;
  border-radius: 24px;
  background: linear-gradient(90deg, #7b3cff, #c84bff);
  font-size: 28px;
  letter-spacing: 4px;
  box-shadow: 0 0 24px rgba(160, 80, 255, 0.55);
}
.signin-stage__stats {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
}
.signin-stat {
  padding: 5px 16px;
  border-radius: 999px;
  font-size: 16px;
  color: #d7f1ff;
  background: rgba(8, 22, 32, 0.55);
  border: 1px solid rgba(120, 220, 255, 0.28);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.85);
}
.signin-stat em {
  font-style: normal;
  font-weight: 800;
  color: #8fe4ff;
  font-variant-numeric: tabular-nums;
}
.signin-wall {
  position: absolute;
  left: 50%;
  top: 150px;
  bottom: 24px;
  transform: translateX(-50%);
  width: min(1400px, 88vw);
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  grid-auto-rows: min-content;
  gap: 12px;
  align-content: center;
  overflow: hidden;
  z-index: 2;
}
.signin-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  animation: signinIn 0.4s ease both;
}
.signin-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 2px solid rgba(255, 255, 255, 0.25);
}
.signin-avatar.is-text {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  font-weight: 700;
  color: #d7f1ff;
  background: linear-gradient(135deg, #2f6f86, #16303f);
}
.signin-nick {
  font-size: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.signin-empty {
  grid-column: 1 / -1;
  margin: auto;
  text-align: center;
}
.signin-empty__title {
  font-size: 28px;
  font-weight: 600;
  color: #c8e8f5;
  margin-bottom: 10px;
}
.signin-empty__tip {
  font-size: 18px;
  color: #8fb0c0;
}
@keyframes signinIn {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes signinFloat {
  from { transform: translate(0, 0) scale(1); }
  to { transform: translate(3%, 4%) scale(1.12); }
}
</style>
